import AttachmentsEditContainer from "./AttachmentsEditContainer";

export default AttachmentsEditContainer;
